// Composables
import AddressBook from '@/views/AddressBook';
import PortfolioV2 from '@/views/Portfolio-v2';
import Platforms from '@/views/Platforms';
import Captcha from '@/views/Captcha';
import Home from '@/views/Home';
import AirdropChecker from '@/views/AirdropChecker';
import {
  RouteLocation,
  RouteRecordRaw,
  createRouter,
  createWebHistory,
} from 'vue-router';
import { demoAddressesString } from '@/constants';
import { useAppStore } from '@/store/app';
import StakeWithUs from '@/views/StakeWithUs';
import NotFound from '@/views/NotFound';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/captcha',
    name: 'Captcha',
    component: Captcha,
  },
  {
    // Temp redirection
    path: '/dashboard',
    redirect: {
      name: 'Home',
    },
  },
  {
    // Temp redirection
    path: '/dashboard/:add?',
    redirect: (to: RouteLocation) => {
      if (!to.params.add || to.params.add === '')
        return {
          name: 'Home',
        };
      return {
        name: 'Portfolio',
        params: { addresses: to.params.add },
      };
    },
  },
  {
    path: '/demo',
    redirect: {
      name: 'Portfolio',
      params: {
        addresses: demoAddressesString,
      },
    },
  },
  {
    path: '/platforms',
    name: 'Platforms',
    component: Platforms,
  },
  {
    path: '/airdrop-checker',
    name: 'AirdropChecker',
    component: AirdropChecker,
  },
  {
    path: '/address-book',
    name: 'AddressBook',
    component: AddressBook,
  },
  {
    path: '/portfolio/:addresses/:bundleId?',
    name: 'Portfolio',
    component: PortfolioV2,
  },
  {
    path: '/stake-with-us',
    name: 'StakeWithUs',
    component: StakeWithUs,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

const captchaIgnoredRoutes = ['Captcha', 'Home', 'AddressBook'];
router.beforeEach((to) => {
  const store = useAppStore();
  if (
    !store.isHuman() &&
    !captchaIgnoredRoutes.includes(to.name?.toString() || '')
  ) {
    return { name: 'Captcha' };
  }
  return true;
});

export default router;
